export const getSavedSearchParams = search => {
  const urlSearchParams = new URLSearchParams(search)

  Array.from(urlSearchParams.keys()).forEach(key => {
    if (key.startsWith('title')) {
      urlSearchParams.delete(key)
    }
  })

  if (!urlSearchParams.has('uploadDate')) {
    urlSearchParams.set('uploadDate', '0')
  }

  return urlSearchParams
}

export default function getSavedSearchURL(search, workspaceId, tab = 'overview') {
  const searchFilters = search?.filters ? `?${search?.filters}` : ''
  const urlSearchParams = getSavedSearchParams(searchFilters)

  return `/workspace/${workspaceId}/saved-search/${search?.id}/${tab}?${urlSearchParams.toString()}`
}
